interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

function Skeleton({ width, height, borderRadius, className = '' }: SkeletonProps) {
  return (
    <div
      className={`bp-skeleton ${className}`}
      style={{ width, height, borderRadius }}
      aria-hidden="true"
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="bp-skeleton-card" aria-busy="true" aria-label="Loading">
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <Skeleton width="48px" height="48px" borderRadius="50%" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Skeleton width="60%" height="16px" />
          <Skeleton width="40%" height="12px" />
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width="100%" height="14px" />
        <Skeleton width="85%" height="14px" />
        <Skeleton width="70%" height="14px" />
      </div>
    </div>
  );
}

export function SkeletonProfile() {
  return (
    <div className="bp-skeleton-card" aria-busy="true" aria-label="Loading profile">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <Skeleton width="72px" height="72px" borderRadius="50%" className="bp-skeleton-circle" />
        <Skeleton width="160px" height="18px" />
        <Skeleton width="100px" height="12px" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <Skeleton width="33%" height="36px" borderRadius="8px" />
          <Skeleton width="33%" height="36px" borderRadius="8px" />
          <Skeleton width="33%" height="36px" borderRadius="8px" />
        </div>
        <Skeleton width="100%" height="14px" />
        <Skeleton width="90%" height="14px" />
        <Skeleton width="75%" height="14px" />
      </div>
    </div>
  );
}

export function SkeletonListItem() {
  return (
    <div style={{ display: 'flex', gap: 12, padding: '12px 0' }} aria-busy="true">
      <Skeleton width="40px" height="40px" borderRadius="8px" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width="70%" height="14px" />
        <Skeleton width="50%" height="12px" />
      </div>
    </div>
  );
}

export function SkeletonDashboard() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }} aria-busy="true" aria-label="Loading dashboard">
      <SkeletonCard />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <SkeletonCard />
        <SkeletonCard />
      </div>
      <SkeletonCard />
    </div>
  );
}
